import { Component, OnInit, Input, ChangeDetectorRef } from "@angular/core";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { S25ItemI } from "../../pojo/S25ItemI";
import { Panel } from "../s25-panel/s25.panels.component";
import { SeAboutOrgComponent } from "./organization/se.about.org.component";
import { S25ItemListComponent } from "../s25-item/s25.item.list.component";
import { StudentEngagementService } from "./student.engagement.service";
import { StudentEngagementOrg } from "./StudentEngagementOrg";
import { Item } from "../../pojo/Item";

@TypeManagerDecorator("s25-ng-se-org-home")
@Component({
    selector: "s25-ng-se-org-home",
    template: `
        <div class="container">
            @if (init) {
                <h1>{{ orgDetails.name }}</h1>

                <!-- across the he top, we'll show large buttons for each area we need to navigate to -->
                @for (navButton of navButtons; track navButton.itemName) {
                    <button class="aw-button" [title]="navButton.title">{{ navButton.itemName }}</button>
                }

                @if (orgDetails) {
                    @if (orgDetails.upcomingEvents && orgDetails.upcomingEvents.length) {
                        <h3>Upcoming Events</h3>
                        <ul>
                            @for (event of orgDetails.upcomingEvents; track event.itemId) {
                                <li>{{ event.title }}</li>
                            }
                        </ul>
                    }

                    <s25-ng-panels [panels]="panels"></s25-ng-panels>
                }
            }
        </div>
    `,
    standalone: false,
})
export class SeOrgHomeComponent implements OnInit {
    @Input() itemId: number;
    init = false;

    constructor(private cd: ChangeDetectorRef) {}
    orgDetails: StudentEngagementOrg.details;

    navButtons: S25ItemI[] = [
        { itemName: "Budgets", destination: "", title: "Not yet configured" },
        { itemName: "Events", destination: "", title: "Not yet configured" },
        { itemName: "Members", destination: "", title: "Not yet configured" },
        { itemName: "Website", destination: "", title: "Not yet configured" },
        { itemName: "Contact Us", destination: "", title: "Not yet configured" },
    ]; // Example navigation buttons, can be customized

    panels: Panel[] = []; // Placeholder for panels, can be populated later

    ngOnInit(): void {
        if (this.itemId) {
            this.getData()
                .then(() => {
                    this.createPanels();
                    this.init = true;
                    this.cd.detectChanges();
                })
                .catch((error) => {
                    console.error("Error loading organization details:", error);
                });
        } else {
            console.warn("No itemId provided, cannot load organization details.");
        }
    }

    async getData(): Promise<void> {
        this.orgDetails = await StudentEngagementService.getOrganizationDetails(this.itemId);
    }

    createPanels(): void {
        // This method can be used to create panels dynamically based on the organization details
        this.panels = [
            {
                header: "About Us",
                id: "about-us",
                section: 0,
                sectionOrder: 1,
                content: {
                    component: SeAboutOrgComponent,
                    inputs: {
                        mission: this.orgDetails.mission,
                        imageUrl: this.orgDetails.image || "assets/default-org-image.png", // Fallback image
                    },
                },
            },
            {
                header: "Members",
                id: "members",
                section: 1,
                sectionOrder: 0,
                content: {
                    component: S25ItemListComponent,
                    inputs: {
                        items: this.orgDetails.members,
                        itemType: Item.Ids.Contact,
                    },
                },
            },
        ];
    }
}
